import React from "react";

import cn from "classnames";

import EmailDynamicVariable from "@mapmycustomers/shared/types/email/EmailDynamicVariable";
import { EntityType } from "@mapmycustomers/shared/types/entity";
import { EntityTypesSupportedByEmailFeature } from "@mapmycustomers/shared/types/entity";

import { useConfigProvider } from "../../ConfigProvider";
import Popconfirm from "../../Popconfirm";
import EmailDynamicVariableChip from "../EmailDynamicVariableChip";

import styles from "./EmailDynamicVariableView.module.scss";

export interface EmailDynamicVariableViewProps {
  className?: string;
  dynamicVariable: EmailDynamicVariable;
  entityType: EntityTypesSupportedByEmailFeature;
  greyed?: boolean;
}

const EmailDynamicVariableView = ({
  className,
  dynamicVariable,
  entityType,
  greyed,
}: EmailDynamicVariableViewProps) => {
  const configProvider = useConfigProvider();

  const clickable = dynamicVariable.allEntitiesHaveValues === false;

  return (
    <span>
      <Popconfirm
        cancelButtonProps={{ hidden: true }}
        description={configProvider.formatMessage(
          "ui.emailDynamicVariableView.someEntitiesMissingData.description"
        )}
        disabled={!clickable}
        okText={configProvider.formatMessage(
          "ui.emailDynamicVariableView.someEntitiesMissingData.ok"
        )}
        placement="topRight"
        title={
          entityType === EntityType.COMPANY
            ? configProvider.formatMessage(
                "ui.emailDynamicVariableView.someEntitiesMissingData.company"
              )
            : configProvider.formatMessage(
                "ui.emailDynamicVariableView.someEntitiesMissingData.person"
              )
        }
        trigger={["click"]}
      >
        <EmailDynamicVariableChip
          allEntitiesHaveValues={dynamicVariable.allEntitiesHaveValues}
          className={cn({ [styles.clickable]: clickable }, className)}
          greyed={greyed}
        >
          {dynamicVariable.displayName}
        </EmailDynamicVariableChip>
      </Popconfirm>
    </span>
  );
};

export default EmailDynamicVariableView;
